import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
import { PageEvent } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-tentative-schedule-master',
  templateUrl: './tentative-schedule-master.component.html',
  styleUrls: ['./tentative-schedule-master.component.scss']
})
export class TentativeScheduleMasterComponent implements OnInit {
 TentativeMasterForm: FormGroup;
//  tentativeMasterSearchForm: FormGroup;
  SessionFilterList: any;
  sessionList: any;
  filteredTentativeSchedule: any[];
  TentativeScheduleList: any[];
   dialogRef: MatDialogRef<any>;
  tsmlist: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  courseList: any; 
  setIntervalSearch: any;
  constructor(public fb: FormBuilder,
     public router: Router,
      public umsService: UmsService,
      private modalPopupService: ModalpopService,
      private datePipe: DatePipe,
      private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
        this.TentativeMasterForm = this.fb.group({
          TsmCircularNumber: new FormControl('', [Validators.required]),
          TsmCircularDate: new FormControl(''),
          TsmSnNo: new FormControl('', [Validators.required]),
          TsmScheduleType: new FormControl('', [Validators.required]),
          SearchString: new FormControl(''),
          ReportCircularNo: new FormControl(''),
        });
        // this.tentativeMasterSearchForm = this.fb.group({
        //   SearchString: new FormControl('')
        // });
        window.scroll(0, 0);
        this.fetchSession();
        this.fetchTentative();
        this.getTSM();
  }

    fetchSession() {
      this.spinner.show();
      const payload = {};
      this.TentativeScheduleList = [];
      this.filteredTentativeSchedule = [];
      // payload['SnDefault'] = id;
      // payload['SnNo'] = id;
      // this.Table = false;
      this.umsService.getSession(payload).subscribe(res => {
        this.sessionList = [];
        if (res.status) {
          this.spinner.hide();
          res.data.forEach(element => {
            if (element.SnStatus == 'O') {
              this.sessionList.push(element);
            }
          });
          this.SessionFilterList = this.sessionList.slice();
        }
        else {
          this.spinner.hide()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      })
    }
    fetchTentative() {
      this.spinner.show();
      const payload = {};
      payload['CdType'] = 'TST';
      this.umsService.getCode(payload).subscribe(res => {
        if (res.status) {
          this.spinner.hide();
          this.TentativeScheduleList = res.data;
          this.filteredTentativeSchedule = this.TentativeScheduleList.slice();
        }
        else {
          this.spinner.hide();
          this.TentativeScheduleList = [];
          this.filteredTentativeSchedule = [];
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
    }
  redirect(to): void {
    this.router.navigate([to]);
  }
  // details() {
  //   this.router.navigate(['tentative-schedule'], {
  //   });
  // }
  details(data: any) {
    console.log('data',data)
    // localStorage.removeItem('tentativeData');
    localStorage.setItem('tentativeData', JSON.stringify(data));
    this.router.navigate(['tentative-schedule'],
       { state: { data } });
  }
  submit(){
    if (this.TentativeMasterForm.invalid) {
      this.TentativeMasterForm.get('TsmCircularNumber').markAsTouched();
      this.TentativeMasterForm.get('TsmSnNo').markAsTouched();
      this.TentativeMasterForm.get('TsmScheduleType').markAsTouched();
      return;
    } else {
      this.saveTSM();
    }
  }
  saveTSM() {
    this.spinner.show();
    const payload = this.TentativeMasterForm.value;
    if (payload.TsmCircularDate) {
      payload.TsmCircularDate = this.convertUTCToIST(payload.TsmCircularDate);
    }
    this.umsService.AddTentativeMaster(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          // });
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          // });
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }
  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString);
    // Convert UTC to IST manually
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
    const istDate = new Date(utcDate.getTime() + istOffset);
    // Format the IST date in the required format
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(istDate.getDate()).padStart(2, '0');
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    const seconds = String(istDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(istDate.getMilliseconds()).padStart(3, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }
  getTSM() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['TsmCircularNumber'] = '';
    payload['TsmCircularDate'] = '';
    payload['TsmSnNo'] = '';
    payload['TsmScheduleType'] = '';
    payload['ReportCircularNo'] = '';
    this.umsService.getTentativeMaster(payload).subscribe(res => {
      console.log('res.data',res.data)
      this.spinner.hide();
      this.tsmlist = res.data;
      this.totalItems = res.data[0].TotalRecords;
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.tsmlist = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

    onPageChange(event: PageEvent): void {
      this.pageSize = event.pageSize;
      const newPageIndex = event.pageIndex + 1;
      this.currentPage = newPageIndex;
      this.getTSM();
      this.keypress()
    }

    
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['SearchString'] = this.TentativeMasterForm.value['SearchString'];
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.getTentativeMaster(payload).subscribe(
      (res) => {
        if(res.status){
          this.tsmlist = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.tsmlist = [];
        this.totalItems = 0
        }
       
        }, (ERROR: HttpErrorResponse) => {
        this.tsmlist = [];
        this.totalItems = 0
      });
    },1000)
   
 
  }
}
